import moment from "moment/moment";
import TableActions from "../../../../../components/Common/TableActions";
import TableLayout from "../../../../../components/TableLayout";
import dataHandler from "../../../../../hooks/dataHandler";
import {
  SERVICE_PROVIDERS_LIST,
  USER_LIST,
} from "../../../../../services/ApiCalls";
import Toggle from "../../../../../components/Common/Toggle";

const TopExperts = () => {
  const {
    setBody,
    body,
    data,
    loader,
    deleteModel,
    setDeleteModel,
    paginationHandler,
    searchHandler,
    total,
    deleteHandler,
    statusChangeHandler,
  } = dataHandler({
    api: USER_LIST,
    extraBody: {
      type: "registered",
      role: "THRIPIST",
      limit: 5,
    },
  });

  const column = [
    {
      head: "#",
      accessor: "#",
      component: (item, key) => {
        return <>{body.limit * (body.page - 1) + key + 1}</>;
      },
    },
    {
      head: "User Name",
      accessor: "name",
      component: (item, key, arr) => (
        <p className="m-0 themeBlue fw-sbold">
          {item?.fname + " " + item?.lname}
        </p>
      ),
    },
    { head: "Email", accessor: "email" },
    { head: "Mobile Number", accessor: "mobileNumber" },
    {
      head: "Registered At",
      accessor: "createdAt",
      component: (item, key, arr) => (
        <>{moment(item.date_created_utc).format("DD-MM-YYYY , HH:MM")}</>
      ),
    },
    // {
    //   head: "Account Type",
    //   accessor: "accountType",
    //   component: (item, key, arr) => (
    //     <p className="m-0 themeBlue fw-sbold">
    //       {findLabelOfAccountType(item.accountType)}
    //     </p>
    //   ),
    // },
    // {
    //   head: "Status",
    //   accessor: "status",
    //   component: (item, key, arr) => (
    //     <Toggle
    //       isChecked={item.status === "active"}
    //       onChange={() =>
    //         statusChangeHandler(
    //           () =>
    //             USER_STATUS_CHANGE({
    //               //need its api
    //               _id: item._id,
    //               status: item.status === "active" ? "inactive" : "active",
    //             }),
    //           key
    //         )
    //       }
    //     />
    //   ),
    // },
    {
      head: "Action",
      accessor: "Action",
      component: (item) => (
        <TableActions viewLink={`/manage-user/detail/${item._id}`} />
      ),
    },
  ];

  return <TableLayout loader={loader} data={data} column={column} />;
};

export default TopExperts;
